export default {
  errors: {
    db_query_failed: "เชื่อมต่อฐานข้อมูลผิดพลาด",
    db_fetch_failed: "การอ่านข้อมูลจากฐานข้อมูลผิดพลาด",
    permission_denied: "คุณไม่มีสิทธิ์เข้าใช้งานระบบนี้",
    invalid_param: "ข้อมูลที่ระบุไม่ถูกต้อง",
    invalid_parameter: "ข้อมูลที่ระบุไม่ถูกต้อง",
    duplicate_tax_id: "หมายเลขผู้เสียภาษีซ้ำ",
	date_wrong_format:"รูปแบบวันที่ไม่ถูกต้อง",
	transaction_not_finish:"รายการขายยังไม่สำเร็จ",
	transaction_already_cancelled:"รายการนี้ถูกยกเลิกไปแล้ว",
	transaction_in_invoice:"ยกเลิกไม่ได้ เนื่องจากรายการอยู่ในใบวางบิล",
	transaction_in_dms:"ยกเลิกไม่ได้ เนื่องจากรายการอยู่ในชุดนำส่ง DMS",
	transaction_not_found:"ไม่พบรายการขายนี้",
	/* ยกเลิกรายการขาย: ข้อความเมื่อไม่ได้คำตอบที่อ่านได้จากเซิร์ฟเวอร์ */
	network_unreachable:"ติดต่อเซิร์ฟเวอร์ไม่ได้ กรุณาตรวจสอบอินเทอร์เน็ตแล้วลองใหม่อีกครั้ง",
	session_expired:"หมดเวลาการเข้าสู่ระบบ กรุณาเข้าสู่ระบบใหม่แล้วลองอีกครั้ง",
	unexpected_server_error:"ระบบขัดข้อง (รหัส {code}) กรุณาลองใหม่ หากยังไม่ได้ให้แจ้งผู้ดูแลระบบ",
	duplicated_policy_number:"หมายเลยกรมธรรม์ซ้ำ",
	status_invalid:"สถานะของรายการไม่ถูกต้อง",
	invalid_parameters:"ข้อมูลที่ระบุไม่ถูกต้อง",
	/* เพิ่มรายการเข้าใบวางบิลที่ออกไปแล้ว — PUT /api/invoice/billings */
	invoice_not_found:"ไม่พบใบวางบิลนี้",
	invoice_add_status_invalid:"เพิ่มรายการไม่ได้ เนื่องจากใบวางบิลนี้ไม่ได้อยู่ในสถานะรอชำระ",
	invoice_add_billing_empty:"ไม่มีรายการที่จะเพิ่มเข้าใบวางบิล",
	invoice_add_billing_not_found:"ไม่พบรายการขายที่เลือก",
	invoice_add_billing_in_invoice:"เพิ่มรายการไม่ได้ เนื่องจากรายการขายอยู่ในใบวางบิลอื่นแล้ว",
	invoice_add_billing_person_diff:"เพิ่มรายการไม่ได้ เนื่องจากรายการขายไม่ได้เป็นของตัวแทนรายเดียวกับใบวางบิล",
	invoice_billing_list_mismatch:"ข้อมูลใบวางบิลไม่ตรงกัน กรุณาติดต่อผู้ดูแลระบบ",
	/* เลขที่ใบวางบิลซ้ำกันหลายใบ ระบุใบที่ต้องการไม่ได้ — ต้องเลือกจากรายการ (ส่ง id) */
	invoice_number_ambiguous:"เลขที่ใบวางบิลนี้ซ้ำกันหลายใบ กรุณาเลือกใบที่ต้องการจากรายการ",
    user: {
      duplicate: "ข้อมูลผู้ใช้งานซ้ำ",
      duplicate_username: "ข้อมูลผู้ใช้งานซ้ำ",
      duplicate_email: "ข้อมูลอีเมล์ซ้ำ",
      blcok_delete_by_self: "ไม่สามารถลบข้อมูลตนเองได้",
      fail: "การปรับปรุงข้อมูลผู้งานผิดพลาด",
      email_wrong_format: "รูปแบบอีเมล์ไม่ถูกต้อง",
      enterprise_empty: "กรุณาระบุองค์กร"
    },
    auth: {
      login_fail: "เข้าสู่ระบบผิดพลาด",
      block: "ผู้ใช้งานถูกระงับ",
      login_success: "เข้าสู่ระบบสำเร็จ",
      logout_success: "ออกจากระบบสำเร็จ",
      unauthoriezed: "เข้าสู่ระบบผิดพลาด",
      reset_invalid_token: "token ไม่ถูกต้อง",
      reset_token_expired: "token หมดอายุ",
      forgot_password_fail: "ลืมรหัสผ่านไม่สำเร็จ",
      reset_password_fail: "เปลี่ยนรหัสผ่านไม่สำเร็จ",
      username_wrong_format: "รูปแบบของชื่อผู้ใช้งานไม่ถูกต้อง",
      password_wrong_format: "รูปแบบของรหัสผ่านไม่ถูกต้อง",
      token: "Toekn ไม่ถูกต้อง",
      password: "รหัสผ่านไม่ถูกต้อง",
      password_confirm: "การยืนยันรหัสผ่านไม่ถูกต้อง"
    },
    profile: {
      change_profile_failed: "แก้ไขข้อมูลผิดพลาด",
      change_password_failed: "แก้ไขรหัสผ่านผิดพลาด",
      password_confirm_not_match: "การยืนยันรหัสผ่านไม่ถูกต้อง",
      password_confirm_wrong_format: "รูปแบบรหัสผ่านไม่ฟถูกต้อง",
      password_old_wrong: "รหัสผ่านเดิมไม่ถูกต้อง"
    },
  },


  profile: {
    profile: "ข้อมูลส่วนตัว",
    birthday: "วันเกิด",
    name: "ชื่อ",
    pname: "คำนำหน้าชื่อ",
    fname: "ชื่อ",
    lname: "นามสกุล",
    phone: "เบอร์โทรศัพท์",
    email: "อีเมล์",
    change_password: "เปลี่ยนรหัสผ่าน",
    password: "รหัสผ่าน",
    password_old: "รหัสผ่านเดิม",
    password_new: "รหัสผ่านใหม่",
    password_confirm: "ยืนยันรหัสผ่าน",
    change_profile_success: "แก้ไขข้อมูลส่วนตัวสำเร็จ",
    change_password_success: "เปลี่ยนรหัสผ่านสำเร็จ",
    type: "ประเภทผู้ใช้งาน",
    gender: "เพศ",
    cardid: "เลขบัตรประจำตัวประชาชน",
    create: "สร้างผู้ใช้งาน",
    change_password: "แก้ไขรหัสผ่าน",
    change_status: "แก้ไขสถานะ",
    role_super_admin: "ผู้ดูแลระบบสูงสุด",
    role_branch_admin: "ผู้ดูแลสาขา",
    role_agent: "ตัวแทน",
    role_user: "ผู้ใช้งาน",
  },
  menu: {
    user: "ผู้ใช้งาน",
    bank: "บัญชีธนาคาร",
    billing: "รายการเรียกเก็บเงิน",
    billing_report: "รายการเรียกเก็บเงิน",
    invoice: "รายการวางบิล",
    branch: "สาขา",
    insure: "ประเภทประกันภัย",
    comm: "คอมมิชชั่น",
    comm_extra: "รายการประเภทประกัน",
    payment: "รายการชำระเงิน",
    ttype: "ช่องทางการขาย",
    person: "ตัวแทน",
    trans: "รายการขาย",
    trans_cancel: "รายการขายที่ยกเลิก",
    customer: "ลูกค้า",
    cash_clear: "บันทึกการรับเงินสด",
    setting: "ตั้งค่า",
    admin: "ผู้ดูแล",
    database: "ฐานข้อมูล",
    wht: "ใบหักภาษี ณ ที่จ่าย",
    finance: "ภาพรวมการเงิน",
    quick_payment: "รับชำระเงินที่สาขา",
    promptpay: "บัญชี PromptPay",
    dms: "ใบนำส่ง DMS",
    branch_money: "เงินสาขา",
  },
  nav: {
    primary: "เมนูหลัก",
    toggleRail: "ย่อ/ขยายเมนู",
    group: {
      sales: "งานขาย / รับชำระ",
      documents: "เอกสาร / รายงาน",
      database: "ฐานข้อมูล",
      settings: "ตั้งค่า",
      admin: "ผู้ดูแล",
    },
    sec: {
      sellingDocs: "เอกสารการขาย",
      collections: "รับชำระเงิน",
      taxDocs: "เอกสารภาษี",
      reports: "รายงาน",
      salesMaster: "ข้อมูลตั้งต้นการขาย",
      receivingMaster: "บัญชีรับเงิน",
    },
  },
  auth: {
    signin: "เข้าสู่ระบบ",
    signout: "ออกจากระบบ",
    username: "อีเมล์หรือชื่อผู้ใช้งาน",
    email: "อีเมล์",
    block: "ผู้ใช้งานนี้ถูกปิด",
    password: "รหัสผ่าน",
    forgetpassword: "ลืมรหัสผ่าน",
    resetpassword: "รีเซ็ตพาสเวิร์ด",
    confirm_reset_password: "ยืนยันการรีเซ็ตพาสเวิร์ดหมายเลข ",
    forgot_password_success: "ลืมรหัสผ่านสำเร็จ กรุณาตรวจสอบอีเมล์",
    reset_password_success: "เปลี่ยนรหัสผ่านสำเร็จ"
  },
  user: {
    create: "สร้างผู้ใช้งาน",
    name: "ชื่อ",
    username: "ชื่อผู้ใช้",
    phone: "เบอร์โทรศัพท์",
    role: "ระดับผู้ใช้งาน",
    type: "ประเภทผู้ใช้งาน",
    create_success: "สร้างผู้ใช้งานสำเร็จ",
    create_fail: "สร้างผู้ใช้งานไม่สำเร็จ",
    edit_unavailable: "ไม่สามารถแก้ไขผู้ใช้งานนี้ได้ (ไม่พบข้อมูลบุคคลที่เกี่ยวข้อง)"
  },
  name: "ชื่อ",
  description: "คำอธิบาย",
  location_x: "ตำแหน่ง (X)",
  location_y: "ตำแหน่ง (Y)",
  group_name: "ชื่อกลุ่ม",
  email: "อีเมล์",
  email_optional: "อีเมล์ (ไม่ระบุ)",
  created: "วันที่สร้าง",
  search: "ค้นหา",
  searchall: "ค้นหาทั้งหมด",
  clear: "ล้าง",
  save: "บันทึก",
  save_continue: "บันทึกต่อเนื่อง",
  back: "กลับ",
  new: "สร้าง",
  edit: "แก้ไข",
  status: "สถานะ",
  download: "ดาวน์โหลด",
  downloadall: "ดาวน์โหลดทั้งหมด",
  copy: "คัดลอก",
  copied: "คัดลอกแล้ว",
  copy_failed: "คัดลอกไม่สำเร็จ",
  product_search: "ค้นหาสินค้า",
  welcome: "ยินดีต้อนรับ",
  myprofile: "ข้อมูลส่วนตัว",
  changepassword: "เปลี่ยนรหัสผ่าน",
  page_notfound: "ขออภัย ไม่พบหน้าที่คุณต้องการ",
  page_notfound_desc:
    "หน้าดังกล่าวอาจมีการเปลี่ยนแปลง ชื่อ หรือ URL ไม่ถูกต้อง กรุณาตรวจสอบลิงค์ที่คุณเข้ามาอีกครั้ง",
  actions: "เมนู",
  detail: "รายละเอียด",
  data: "ข้อมูล",
  to: "ถึง",
  of: "จาก",
  row_select: "ข้อมูลที่ถูกเลือก",
  yes: "ใช่",
  no: "ไม่ใช่",
  ok: "ตกลง",
  cancel: "ยกเลิก",
  upload_file: "เพิ่มไฟล์",
  bg_admin: "ตั้งค่าผู้ดูแลระบบ",
  comportal: "ตั้งค่าผู้ใช้งาน",
  add: "เพิ่ม",
  close: "ปิด",
  please_select: "กรุณาเลือก",
  create: "สร้าง",
  confirm: "ยืนยัน",
  create_success: "สร้างข้อมูลสำเร็จ",
  delete_confirm: "ยืนยันการลบข้อมูล",
  delete_confirm_text: "คุณต้องการลบข้อมูล ",
  delete_confirm_question: "คุณต้องการลบข้อมูล ",
  delete_success: "ลบข้อมูลสำเร็จ",
  delete_fail: "ลบข้อมูลไม่สำเร็จ",
  cancel_confirm: "ยืนยันการยกเลิกข้อมูล",
  cancel_confirm_text: "คุณต้องการยกเลิกข้อมูล ",
  cancel_confirm_question: "คุณต้องการยกเลิกข้อมูล ",
  cancel_success: "ยกเลิกข้อมูลสำเร็จ",
  cancel_fail: "ยกเลิกข้อมูลไม่สำเร็จ",
  edit_success: "แก้ไขข้อมูลสำเร็จ",
  edit_fail: "แก้ไขข้อมูลไม่สำเร็จ",
  created_at : "วันที่สร้าง",

  status_active: "ใช้งาน",
  status_not_active: "ไม่ใช้งาน",

    fname: "ชื่อ",
    lname: "นามสกุล",
    birthday: "วันเกิด",
    // Action
    create : "สร้าง",
    delete : "ลบ",
    edit : "แก้ไข",

    InsureLevel : "ระดับประกันภัย",
    InsureUpper : "กลุ่มประกันภัย",
  lmg: {
    pool_balance: "ยอดคงเหลือ pool",
    pool_transfer_total: "เงินโอน",
    pool_cash_total: "เงินสด",
    pool_reserve_total: "สำรองจ่าย",
    pool_total: "รวมทั้งหมด",
    pool_by_account: "แยกตามบัญชี",
    policy_status: "สถานะรายกรมธรรม์",
    paid_status: "การชำระ",
    payment_method: "วิธีชำระ",
    account: "บัญชี",
    dms_submitted: "นำส่งแล้ว",
    dms_not_submitted: "ยังไม่นำส่ง",
    paid_yes: "จ่ายแล้ว",
    paid_no: "ยังไม่จ่าย",
    dms_batch: "ใบนำส่ง DMS",
    batch_number: "เลขที่ใบนำส่ง",
    batch_date: "วันที่นำส่ง",
    round: "รอบ",
    select_policies: "เลือกกรมธรรม์",
    premium_original: "เบี้ยเดิม",
    premium_adjusted: "เบี้ยที่แก้ไข",
    adjust_note: "หมายเหตุการแก้ไข",
    submit_dms: "บันทึกใบนำส่ง",
    dms_pdf: "ไฟล์แนบ (PDF/รูป)",
    dms_item_count: "จำนวนกรมธรรม์",
    dms_total: "ยอดรวม",
    dms_status: "สถานะ",
    dms_status_submitted: "ส่งแล้ว",
    dms_status_cancelled: "ยกเลิก",
    dms_filter_year: "ปีที่นำส่ง",
    dms_filter_all_months: "ทุกเดือน (ทั้งปี)",
    dms_filter_year_first: "เลือกปีก่อน",
    dms_filter_clear: "ล้างตัวกรอง",
    dms_paid_date: "วันชำระ",
    dms_unpaid: "ยังไม่ชำระ",
    dms_delete_confirm: "ยืนยันการลบใบนำส่งนี้? ระบบจะคืนยอดเงินเข้า pool สาขา",
    export_pdf: "ดาวน์โหลด PDF",
    export_xlsx: "ดาวน์โหลด Excel",
    agent: "ตัวแทน",
    card_number: "เลขบัตร",
    created: "วันที่สร้าง",
    edit: "แก้ไข",
    fname: "ชื่อ",
    lname: "นามสกุล",
    extra_charge: "เก็บเพิ่มเติม",
	address_customer:"ที่อยู่",
	address_province:"จังหวัด",
	address_district:"อำเภอ",
	address_subdistrict:"ตำบล",
	address_zipcode:"รหัสไปรษณีย์",

    wht: "ใบหักภาษี ณ ที่จ่าย",
    name: "North And East Broker",
    code: "โค้ด",
    bank: "บัญชีธนาคาร",
    branch: "สาขา",
    comm: "คอมมิชชั่นโปรไฟล์",
    comm_extra: "รายการประเภทประกัน",
    insure: "ประกันภัย",
    insure_type: "ประเภทประกันภัย",
    insure_plan: "แผน",
    data_type: "ชนิดข้อมูล",
    insure_data_type: "ประเภทข้อมูล",
    insure_data_type_1: "ประกันรถยนต์",
    insure_data_type_2: "ประกันสุขภาพ",
    insure_data_type_3: "ประกันวินาศภัย (อาคาร)",
    insure_data_type_4: "ประกันวินาศภัย (ขนส่ง)",
    insure_data_type_5: "ประกันเบ็ดเตล็ด",
    insure_data_type_other: "อื่น ๆ",
    insure_inactive_tag: "ปิดใช้งาน",
    insure_browse_roots: "หมวดหลัก",
    insure_browse_root: "หมวดหลัก",
    insure_browse_back: "กลับ",
    insure_browse_empty: "ไม่มีรายการย่อย",
    insure_browse_more_crumbs: "เส้นทางที่ซ่อนไว้",
    insure_browse_columns_aria: "เรียกดูแบบคอลัมน์",
    insure_select_to_view: "เลือกรายการเพื่อดูรายละเอียด",
    insure_level_n: "ระดับ {n}",
    insure_status_active: "● ใช้งาน",
    insure_status_inactive: "○ ปิดใช้งาน",
    insure_has_children_n: "มีหมวดย่อย {n} รายการ",
    insure_no_children: "ไม่มีหมวดย่อย (เป็นรายการปลายสาย/สินค้า)",
    insure_action_add_child: "+ เพิ่มลูก",
    insure_action_add_sibling: "+ เพิ่มพี่น้อง",
    insure_action_edit: "แก้ไข",
    insure_action_deactivate: "ปิดใช้งาน",
    insure_action_reactivate: "เปิดใช้งาน",
    insure_action_move: "ย้ายไป…",
    insure_deactivate_blocked: "ปิดใช้งานไม่ได้: มีหมวดย่อย — ย้ายหรือลบก่อน",
    insure_move_soon: "ฟีเจอร์ย้าย — เร็วๆ นี้ (Phase 2)",
    insure_search_empty: "ไม่พบรายการ",
    insure_search_more: "แสดงเพิ่ม",
    insure_search_leaf: "รายการปลายทาง",
    insure_search_branch: "มีรายการลูก",
    insure_required: "กรุณาเลือกสินค้าประกัน",
    product_picker_placeholder: "เลือกสินค้าประกัน",
    product_picker_title: "เลือกสินค้าประกัน",
    product_picker_search_placeholder: "ค้นหาสินค้าประกัน…",
    product_picker_loading: "กำลังโหลด…",
    product_picker_empty: "ไม่พบรายการ",
    product_picker_clear: "ล้างรายการที่เลือก",
    insure_strip_prefix: "ซ่อนเลขลำดับนำหน้า",
    insure_hide_type: "ซ่อนป้ายประเภท",
    person: "ตัวแทน",
    ttype: "ช่องทางการขาย",
    user: "ผู้ใช้งาน",
    customer: "ลูกค้า",
    trans: "รายการขาย",
    billing: "การเรียกเก็บเงิน",
    sale_date: "วันที่ขาย",

    detail: "ค่าเสียหายส่วนแรก (DD)",

    // Bank
    bank_name: "ชื่อธนาคาร",
    bank_account: "เลขบัญชีธนาคาร",
    bank_code: "รหัสสาขา",
    promptpay: "PromptPay",
    promptpay_enabled: "บัญชีนี้รองรับ PromptPay",
    promptpay_type: "ประเภท PromptPay",
    promptpay_id: "เลข PromptPay",
    show_on_invoice: "พิมพ์เลขบัญชีนี้ในใบวางบิล",
    qr_on_invoice: "ใช้ PromptPay ของบัญชีนี้แปะ QR ในใบวางบิล",
    pp_type_phone: "เบอร์โทรศัพท์",
    pp_type_taxid: "เลขประจำตัวผู้เสียภาษี / บัตรประชาชน",
    pp_type_ewallet: "e-Wallet ID",
    on_invoice: "บนใบวางบิล",
    account_type: "ประเภทบัญชี",
    account_type_hq: "สนญ. (โอนตรงสำนักงานใหญ่)",
    account_type_branch_transfer: "สาขาโอน",
    account_type_branch_cash: "สาขาเงินสด",
    account_type_unset: "ยังไม่กำหนด",
    account_select: "เลือกบัญชีรับเงิน",
    commission_deducted: "ตัวแทนหักคอมฯ แล้ว",
    commission_amount: "ค่าคอมมิชชั่น",
    visible_all_branch: "ใช้ได้ทุกสาขา",

    // Person
    agent_code: "รหัสตัวแทน",
    with_holding_tax: "ณ ที่จ่าย",
    tel: "โทรศัพท์",
    email: "อีเมล์",
    address: "ที่อยู่",
    subdistrict: "ตำบล",
    city: "อำเภอ",
    province: "จังหวัด",
    postcode: "รหัสไปรษณีย์",

    card_type: "ประเภทบัตร",
    card_type_1: "บัตรประชาชน",
    card_type_2: "Passport",
    card_type_3: "นิติบุคคล",
  

    // transaction
    transaction_id: "หมายเลขการขาย",
    cancel_trans: "ยกเลิกรายการขาย",
    trans_create: "สร้างรายการขาย",
    trans_detail: "ข้อมูลรายการขาย",
    trans_report_discount: "ใบจ่ายส่วนลด",
    discount : "ส่วนลด",
    moreDiscount : "ส่วนลดพิเศษ",
    trans_report: "รายงานการขาย",
    // User
    user_type: "ประเภทผู้ใช้งาน",


    // Billing
    billing : "รายการเรียกเก็บเงิน",
    billing_bill_id : "หมายเลขการเรียกเก็บเงิน",
    billing_paid_via : "วิธีชำระเงิน",
    billing_note : "หมายเหตุ",
    note : "หมายเหตุ",
    billing_period : "แบ่งชำระ",
    payment : "ชำระเงิน",
    paid_type_cash : "เงินสด",
    paid_type_check : "เช็ค",
    paid_type_transfer : "โอนเงิน",
    paid_file : "หลักฐานการชำระเงิน",
    paid_status : "สถานะการชำระเงิน",
    paid_time : "เวลาที่ชำระเงิน",
    paid_via : "วิธีชำระเงิน",
    paid_date : "วันที่ชำระเงิน",
    view_detail : "ดูรายละเอียด",
    tranfer_image : "หลักฐานการโอน",
    updated_at : "อัปเดตล่าสุด",
    commission_percent : "% ค่าคอมมิชชั่น",
    tax_percent : "% ภาษี",
    trans_type : "ประเภทงาน",

    recorder: "ผู้บันทึก",
    due_date: "วันครบกำหนดชำระ",
    due_round: "รอบเก็บเงิน",
    month: "เดือน",
    year: "ปี",
    amount: "จำนวนเงิน",
	invoice_amount_all:"เบี้ยรวม",
	invoice_amount:"เบี้ยสุทธิ",
	invoice_pay_amount:"ยอดรวมชำระ",

    sort : "เรียงลำดับ",

    // Comm
    comm_incentive: "ค่าส่งเสริม (บาท)",
    comm_limitCnt: "จำกัด (ครั้งต่อปี)",
    comm_amount: "ค่าคอมมิชชั่น",
    comm_adjust: "ค่าคอมมิชชั่นพิเศษ",
    comm_amount_percent: "ค่าคอมมิชชั่น (%)",
    change_credit_limit: "แก้ไขวงเงิน",
    credit: "เครดิต",
    credit_limit: "วงเงิน",
    credit_temp: "วงเงินชั่วคราว",
    credit_range: "ระยะเวลาเครดิต (วัน)",

    person_upper: "หัวหน้าทีม",
    person_type: "ช่องทางการขาย",
    owner_person: "ตัวแทนประกันภัย",
    policy_number: "หมายเลขกรมธรรม์",
    dms_number: "หมายเลข DMS",
    license_plate: "ทะเบียนรถ",
    license_plate_min: "ทะเบียนรถต้องมีอย่างน้อย 2 ตัวอักษร ระบบจึงข้ามเงื่อนไขนี้",


    // Person
    taxid: "หมายเลขผู้เสียภาษี",
    postcode: "รหัสไปรษณีย์",
    protection_date: "ระยะเวลาคุ้มครอง",

    cid: "หมายเลขบัตรประจำตัวประชาชน / Passport",
    payment_method: "ช่องทางชำระเงิน",
    payment_amount: "จำนวนเงินที่ชำระไว้แล้ว",
    trans_payment_amount: "จำนวนเงินที่ต้องชำระ",
    payment_comm: "ค่าคอมมิชชั่นที่หักไว้แล้ว",
    payment_date: "วันที่ชำระเงิน",
    payment_create: "สร้างรายการชำระเงิน",
    payment_source: "ที่มา",
    paid_at_branch: "ชำระที่สาขา",
    payment_image: "หลักฐานการชำระเงิน",
    attachments: "หลักฐานการชำระ (ไฟล์แนบ)",
    add_files: "เลือกไฟล์ (สูงสุด 5 ไฟล์)",
    max_files_5: "แนบได้สูงสุด 5 ไฟล์",
    file_too_large: "ไฟล์มีขนาดเกิน 5MB",
    file_type_invalid: "รองรับเฉพาะไฟล์รูปภาพหรือ PDF เท่านั้น",
    remove_file: "ลบไฟล์",
    no_attachments: "ไม่มีไฟล์แนบ",
    policy_start_date : "เริ่มการคุ้มครอง",
    policy_end_date : "สิ้นสุดการคุ้มครอง",

    trans_amount: "เบี้ยสุทธิ",
    summary_amount: "เบี้ยรวม",
    trans_date: "วันที่บันทึก",
    cash_clear: "เงินค้างที่พนักงาน",
    cash_clear_title: "บันทึกการรับเงินสดจากพนักงาน",
    cash_clear_date: "วันที่รับเงินจากพนักงาน",
    cash_clear_recorder: "ผู้บันทึกการรับเงินจากพนักงาน",
    cash_clear_amount: "จำนวนเงินค้างที่พนักงาน",
    cash_out_branch: "นำเงินออกจากสาขา",


    insure_year: "ปีที่ทำ",
    trans_detail: "รายการ",
    age: "อายุ",
    insure_sum: "ทุนประกัน",
    car_model: "รุ่นรถ",
    car_year: "ปีรถ",
    billing_address : "สถานที่ตั้ง",
    code_disaster : "รหัสภัย",
    chassis_number : "รหัสตัวถัง",
    insurance_scope : "ขอบเขต",


    pay_amount : "ยอดรวมชำระ",
    tax_amount : "ภาษีส่วนลด",
    net_amount : "คงเหลือ",
    commission_discount : "หักส่วนลด",
    billCharge : "ชาร์จต่องวด",
    renew : "ต่ออายุ",
    policyNumberUpper : "หมายเลขกรมธรรม์เดิม",
    whTax : "ณ ที่จ่าย",
    invoice : "รายการวางบิล",
    invoice_number : "หมายเลขวางบิล",
    invoice_add_billing : "เพิ่มรายการเข้าใบวางบิล",
    invoice_add_billing_hint : "เพิ่มรายการขายเข้าใบวางบิลเลขที่",
    invoice_add_billing_confirm : "ยืนยันเพิ่มรายการเข้าใบวางบิล?",
    invoice_add_billing_rows : "จำนวนรายการที่เพิ่ม",
    invoice_add_billing_success : "เพิ่มรายการเข้าใบวางบิลสำเร็จ",
    invoice_add_billing_fail : "เพิ่มรายการเข้าใบวางบิลไม่สำเร็จ",
    invoice_add_billing_no_rows : "ไม่พบรายการขายที่ยังไม่ถูกวางบิลที่รวมเข้าใบวางบิลนี้ได้",
    invoice_add_billing_scope_agent : "แสดงเฉพาะรายการที่ยังไม่ถูกวางบิลของตัวแทนรายนี้",
    invoice_add_billing_scope_group : "แสดงเฉพาะรายการที่ยังไม่ถูกวางบิลของกลุ่มคอมมิชชันลูกค้าตรง (รวมทุกอัตราส่วนลด)",
    back : "กลับ",
    date : "วันที่",

    items: "รายการ",
    sale_list: "รายการขาย",
    finance_detail: "รายละเอียดบิล",
    finance_per_person: "สรุปต่อพนักงาน/ตัวแทน",
    finance_total: "รวมทั้งหมด",
    finance_status_1: "ยังไม่สร้างรายการวางบิล",
    finance_status_2: "สร้างรายการวางบิล ยังไม่ได้ชำระเงิน",
    finance_status_3: "ชำระเงินแล้ว",
    finance_cash_submission: "การนำส่งเงินสดจากพนักงาน",
    cash_clear_status: "สถานะเงินสด",
    cash_cleared: "นำส่งแล้ว",
    cash_outstanding: "ค้างที่พนักงาน",
    cash_collected: "เก็บแล้ว",
    cash_total: "ยอดเงินสดรวม",


	book_id:"เล่มที่",
	number_id:"เลขที่",
	start_date:"วันที่เริ่มต้น",
	end_date:"วันที่สิ้นสุด",
	effect_date:"วันที่มีผล",
	car_type:"ประเภทรถยนต์",
	refund_amount:"คืนเบี้ยสุทธิ",
	refund_amount_all:"คืนเบี้ยรวม",
	per_page : "จำนวนรายการต่อหน้า",
  }
};
